import { useState } from "react";
import axios from "axios";
import MainLayout from "./layouts/MainLayout";

function AddTicket() {

  const [clientId,setClientId]=useState("");
  const [technicianId,setTechnicianId]=useState("");
  const [managerId,setManagerId]=useState("");

  const [title,setTitle]=useState("");
  const [description,setDescription]=useState("");
  const [priority,setPriority]=useState("Medium");

  const saveTicket=async(e)=>{

    e.preventDefault();

    try{

      const token=localStorage.getItem("token");

      const response=await axios.post(

      "https://saleupcall.com/api/add-ticket.php",

      {

        client_id:clientId,
        technician_id:technicianId || null,
        manager_id:managerId || null,

        title,
        description,
        priority

      },

      {

        headers:{

          Authorization:`Bearer ${token}`

        }

      }

      );

      console.log(response.data);

      if(response.data.status){

        alert(

        "Ticket Created : " +

        response.data.ticket_number

        );

        setClientId("");
        setTechnicianId("");
        setManagerId("");

        setTitle("");
        setDescription("");

        setPriority("Medium");

      }
      else{

        alert(
          response.data.message
        );

      }

    }
    catch(error){

      console.log(error);

    }

  };

  return(

    <MainLayout>

      <div style={{padding:"20px"}}>

        <h2>Create Ticket</h2>

        <form onSubmit={saveTicket}>

          <input
          type="text"
          placeholder="Client ID"
          value={clientId}
          onChange={(e)=>
          setClientId(
          e.target.value
          )}
          />

          <br/><br/>

          <input
          type="text"
          placeholder="Technician ID"
          value={technicianId}
          onChange={(e)=>
          setTechnicianId(
          e.target.value
          )}
          />

          <br/><br/>

          <input
          type="text"
          placeholder="Manager ID"
          value={managerId}
          onChange={(e)=>
          setManagerId(
          e.target.value
          )}
          />

          <br/><br/>

          <input
          type="text"
          placeholder="Title"
          value={title}
          onChange={(e)=>
          setTitle(
          e.target.value
          )}
          />

          <br/><br/>

          <textarea
          placeholder="Description"
          value={description}
          onChange={(e)=>
          setDescription(
          e.target.value
          )}
          />

          <br/><br/>

          <select
          value={priority}
          onChange={(e)=>
          setPriority(
          e.target.value
          )}
          >

          <option value="Low">

          Low

          </option>

          <option value="Medium">

          Medium

          </option>

          <option value="High">

          High

          </option>

          <option value="Critical">

          Critical

          </option>

          </select>

          <br/><br/>

          <button
          type="submit"
          >

          Create Ticket

          </button>

        </form>

      </div>

    </MainLayout>

  );

}

export default AddTicket;